import React from 'react'
import sty from './index.module.css'
function IconActive() {
  return (
    <div className={`${sty.first}`}>
        <div className={`${sty.second}`}>
            <div className={`${sty.third}`}>
                <div className={`${sty.fourth}`}>
                </div>
            </div>
        </div>
    </div>
  )
}

export default IconActive